import { useEffect, useState } from 'react';
import { Col, DatePicker, Form, Modal, Row, Select } from 'antd';
import { dateToDayjs, dateToStringWT, getExpiresFromString } from '@/utils';
import { useGetFosterCareLicenseTypesQuery } from '@/services/general-api';
import { useSaveParentFosterCareMutation } from '@/services/parent-api';
import moment from 'moment';
// import Select from '@/components/select';

const EditModal = ({ parentId, open, data, refetch, refetchHasLicense, setShouldRefetch, onClose }) => {
  const { data: typeData, isLoading: loadingTypeData } = useGetFosterCareLicenseTypesQuery();
  const [saveFosterCare, { isLoading: saving }] = useSaveParentFosterCareMutation();
  const [form] = Form.useForm();
  const isNew = !data?.parentFosterCareLicenseHistoryId;

  const [effective, setEffective] = useState();

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        form.resetFields();
      });
    }
  }, [open, form]);

  const onFinish = async (body) => {
    body.expires = getExpiresFromString(effective);
    body.effective = effective;
    body.active = true;

    try {
      await saveFosterCare({ parentId, id: data?.parentFosterCareLicenseHistoryId, body }).unwrap();
      refetch();
      refetchHasLicense();
      onClose();
      setShouldRefetch(true);
    } catch (err) {}
  };

  return (
    <>
      <Modal
        title={isNew ? 'Add License' : 'Edit License'}
        open={open}
        okText={isNew ? 'Add' : 'Save'}
        confirmLoading={saving}
        onOk={() => form.submit()}
        onCancel={onClose}
      >
        <Form
          layout="vertical"
          form={form}
          initialValues={{
            effective: dateToDayjs(data?.effective),
            type: {
              id: data?.type.id,
            },
          }}
          onFinish={onFinish}
        >
          <Row gutter={24}>
            <Col xs={24} md={12}>
              <Form.Item name={['type', 'id']} label="Type" rules={[{ required: true }]}>
                <Select options={typeData} loading={loadingTypeData} fieldNames={{ label: 'name', value: 'id' }} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item name="effective" label="Effective" rules={[{ required: true }]}>
                <DatePicker
                  format="M/D/YYYY"
                  onBlur={(e) => {
                    const inputVal = e.target.value;
                    const validDate = moment(dateToStringWT(inputVal), 'MM/DD/YYYY');
                    if (validDate.isValid()) {
                      // setEffective(validDate);
                      form.setFieldsValue({
                        effective: validDate,
                      });
                      setEffective(dateToStringWT(validDate));
                    } else {
                      form.setFieldsValue({
                        effective: null,
                      });
                    }
                  }}
                  onChange={(day) => {
                    setEffective(dateToStringWT(day));
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              {effective && <Form.Item label="Expires">{getExpiresFromString(effective)}</Form.Item>}
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default EditModal;
